export function formatImageName(slot_key = '') {
  // remove underscores and capitalize first letter
  return slot_key
    .replace(/_/g, ' ')
    .replace(/^\w/, match => match.toUpperCase())
}
